import SubSkillResult from './model';

export default SubSkillResult;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/SkillResults/SubSkillResults/index.js